// Styles
import styles from './VirtualizedTableGroup.module.css';

/**
 * VirtualizedTableGroup - Inner container for virtualized table items
 * @param {object} params
 * @param {string} params.height - Height of the container (e.g., "1000px")
 * @param {React.ReactNode} params.children - Children to render
 * @returns {JSX.Element} VirtualizedTableGroup component
 */
function VirtualizedTableGroup({ height, children }) {
  return (
    <div
      style={{
        height,
      }}
      className={styles['virtualized-table-groups']}
    >
      {children}
    </div>
  );
}

export default VirtualizedTableGroup;
